import SalesforceLogo from '@clearkit/icons/services/Salesforce';

import salesforceTheme from './theme';

export default {
  logo: SalesforceLogo,
  theme: salesforceTheme,
};
